import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CForm,
  CFormGroup,
  CLabel,
  CInput,
  CImg,
} from "@coreui/react";
import { Link } from "react-router-dom";
import {
  fetchSpecialities,
  addSpeciality,
  editSpeciality,
  deleteSpeciality,
} from "../../actions/specialityAction";
import { imgUrl } from "src/actions/types";

const Specialities = ({
  loading,
  specialities,
  error,
  fetchSpecialities,
  addSpeciality,
  editSpeciality,
  deleteSpeciality,
}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentSpeciality, setCurrentSpeciality] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    SpecID: "",
    name: "",
    image: null,
  });

  const DEFAULT_IMAGE = "/assets/img/specialities/stethoscope-64.png";
  useEffect(() => {
    fetchSpecialities();
  }, [fetchSpecialities]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;
    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const urlToFile = async (url, filename, mimeType) => {
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
  };
  const handleAddSpeciality = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();
    formPayload.append("SpecID", formData.id);
    formPayload.append("SpecialitiesName", formData.name);

    try {
      if (formData.image) {
        // 1. Agar user ne image select ki hai
        formPayload.append("ImageURL", formData.image);
      } else {
        // 2. Agar user ne image select NAHI ki, toh default image ko binary banao
        // Ye function assets folder se image uthayega aur use File object bana dega
        const defaultFile = await urlToFile(
          DEFAULT_IMAGE,
          "default_speciality.jpg",
          "image/jpeg"
        );
        formPayload.append("ImageURL", defaultFile);
      }

      // Ab server ko hamesha binary file milegi (req.file empty nahi hoga)
      await addSpeciality(formPayload);

      setShowAddModal(false);
      setFormData({ id: "", SpecID: "", name: "", image: null });
      fetchSpecialities();
      alert("Speciality Added Successfully!");
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";
      alert("Error: " + errorMsg);
      console.error(error);
    }
  };

  const handleEditSpeciality = async (e) => {
    e.preventDefault();
    if (!formData || !formData.id) {
      alert("Error: Speciality data is missing.");
      return;
    }

    const formPayload = new FormData();
    formPayload.append("id", formData.id);
    formPayload.append("SpecID", formData.SpecID);
    formPayload.append("SpecialitiesName", formData.name);
    console.log(formData);
    if (formData.image) {
      formPayload.append("ImageURL", formData.image);
    }
    try {
      await editSpeciality(formPayload);
      setShowEditModal(false);
      setCurrentSpeciality(null);
      setFormData({ id: "", SpecID: "", name: "", image: null });
      fetchSpecialities();
    } catch (error) {
      alert("Edit failed.");
    }
    console.log(formData.image);
  };

  const openEditModal = (speciality) => {
    setCurrentSpeciality(speciality);
    setFormData({
      id: speciality.id,
      SpecID: speciality.SpecID,
      name: speciality.SpecialitiesName,
      image: speciality.ImageURL, // set to string for preview
    });
    setShowEditModal(true);
  };

  const openDeleteModal = (speciality) => {
    setCurrentSpeciality(speciality);
    setShowDeleteModal(true);
  };

  const handleDeleteSpeciality = async () => {
    try {
      if (currentSpeciality?.id) {
        await deleteSpeciality(currentSpeciality.id);
        setShowDeleteModal(false);
        setCurrentSpeciality(null);
        fetchSpecialities();
      }
    } catch (error) {
      alert("Failed to delete speciality.");
    }
  };

  return (
    <div className="page-wrapper ml-0">
      <div className="content-container">
        <div className="page-header">
          <div className="page-header filter-bar rounded">
            <div className="row align-items-center">
              <div className="col">
                <h4 className="page-title"> Specialities </h4>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/doctor/dashboard">Admin Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Specialities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <CCard>
          <CCardHeader className="d-flex justify-content-between align-items-center">
            <button
              className="btn btn-info rounded-pill"
              onClick={() => setShowAddModal(true)}
            >
              Add Speciality
            </button>
          </CCardHeader>
          <CCardBody>
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <table className="table table-hover table-center mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Specialities</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {specialities.map((spec) => (
                    <tr key={spec.SpecID}>
                      <td>{spec.SpecID}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-sm mr-2">
                            <CImg
                              src={
                                spec.ImageURL
                                  ? `${imgUrl}${spec.ImageURL}`
                                  : DEFAULT_IMAGE
                              }
                              alt={spec.SpecialitiesName}
                              className="rounded-circle"
                              width={40}
                              height={40}
                            />
                          </span>
                          <span>{spec.SpecialitiesName}</span>
                        </div>
                      </td>
                      <td className="text-right">
                        <button
                          size="sm"
                          className="i-btn-edit"
                          onClick={() => openEditModal(spec)}
                        ></button>
                        <button
                          className="i-btn-delete"
                          onClick={() => openDeleteModal(spec)}
                        ></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </CCardBody>
        </CCard>

        {/* Add Modal */}
        <CModal
          show={showAddModal}
          onClose={() => setShowAddModal(false)}
          centered
        >
          <CModalHeader
            className="bg-info text-white"
            closeButton
            closeVariant="white"
          >
            Add Speciality
          </CModalHeader>
          <CModalBody>
            <CForm onSubmit={handleAddSpeciality}>
              <CFormGroup>
                <CLabel htmlFor="id">SpecID</CLabel>
                <CInput
                  type="text"
                  id="id"
                  name="id"
                  value={formData.id}
                  onChange={handleInputChange}
                  required
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel htmlFor="name">Speciality Name</CLabel>
                <CInput
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel htmlFor="image">Upload Image</CLabel>
                <CInput
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  onChange={handleInputChange}
                />
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "5px",
                    fontWeight: "bold",
                  }}
                >
                  Always upload image in JPG or PNG format.
                </p>
                <img
                  src={
                    formData.image && typeof formData.image !== "string"
                      ? URL.createObjectURL(formData.image) // Agar nayi file select ki hai
                      : DEFAULT_IMAGE // Agar kuch select nahi kiya
                  }
                  alt="Preview"
                  style={{
                    marginTop: "10px",
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              </CFormGroup>
              <button className="save-button">Save</button>
            </CForm>
          </CModalBody>
        </CModal>

        {/* Edit Modal */}
        <CModal
          show={showEditModal}
          onClose={() => setShowEditModal(false)}
          centered
        >
          <CModalHeader className="bg-info text-white " closeButton>
            Edit Speciality
          </CModalHeader>
          <CModalBody>
            <CForm onSubmit={handleEditSpeciality}>
              <CFormGroup>
                <CLabel htmlFor="id">ID</CLabel>
                <CInput
                  type="text"
                  id="id"
                  name="id"
                  value={formData.id}
                  readOnly
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel htmlFor="SpecID">Spec ID</CLabel>
                <CInput
                  type="text"
                  id="SpecID"
                  name="SpecID"
                  value={formData.SpecID}
                  readOnly
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel htmlFor="name">Speciality Name</CLabel>
                <CInput
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel htmlFor="image">Upload Image</CLabel>
                <CInput
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  onChange={handleInputChange}
                />
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "5px",
                    fontWeight: "bold",
                  }}
                >
                  Always upload image in JPG or PNG format.
                </p>
                <img
                  src={
                    formData.image
                      ? typeof formData.image === "string"
                        ? `${imgUrl}${formData.image}` // Existing image from server
                        : URL.createObjectURL(formData.image) // New file selected by admin
                      : DEFAULT_IMAGE // Fallback
                  }
                  alt="Preview"
                  style={{
                    marginTop: "10px",
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              </CFormGroup>
              <button className="update-button">Update</button>
            </CForm>
          </CModalBody>
        </CModal>

        {/* Delete Modal */}
        <CModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          centered
        >
          <CModalHeader closeButton>Delete Speciality</CModalHeader>
          <CModalBody>
            Are you sure you want to delete speciality "
            {currentSpeciality?.SpecialitiesName}"?
            <div className="mt-3 d-flex justify-content-between">
              <button
                className="delete-button"
                onClick={handleDeleteSpeciality}
              >
                Delete
              </button>
              <button
                className="cancel-button"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </CModalBody>
        </CModal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.specialities.loading,
  specialities: state.specialities.specialities,
  error: state.specialities.error,
});

export default connect(mapStateToProps, {
  fetchSpecialities,
  addSpeciality,
  editSpeciality,
  deleteSpeciality,
})(Specialities);
